import styled from 'styled-components';
import { Icon } from '@codex/icons';
import { OnOffSwitch } from '@codex/basics';
import colors from '@codex/colors';

const Chevron = styled(Icon)`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;

const SectionHeader = styled.tr`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.link.default};
  border-top: 2px solid ${(props) => props.theme.colors.link.default};
`;

const SpinnerContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -15%);
`;

const CompareProductContainer = styled.div`
  padding-bottom: 20px;
`;

const CompareTable = styled.table`
  table-layout: auto;
  background: ${colors.shades[7]};
  border-collapse: collapse;
  tr.highlighted {
    background: #b9e1fc;
  }
  tr th, tr td {
    border: 1px solid ${colors.shades[5]};
    padding: 5px 7px;
    vertical-align: top;
    text-align: left;
  }
  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Separator = styled.div`
  border-bottom: 1px solid  ${colors.shades[5]};
`;
const StickyTable = styled(CompareTable)`
  && {
    table-layout: fixed;
    position: sticky;
    z-index: 3;
    top: 68px;
    box-shadow: 0px 2px 10px -4px rgba(0,0,0,0.75);
  }
`;

const Cell = styled.td`
  width: 20%;
  overflow: hidden;
`;

const CellProduct = styled(Cell)`
  && {
    position: relative;
    text-align: center;
    button {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 0 0 0 3px;
      color: ${colors.shades[3]};
      background: ${colors.shades[5]};
      padding: 0;
      text-transform: uppercase;
      font-weight: bold;
      text-decoration: none;
    }
    img: {
      margin-top: 10px;
    }
    strong {
      display: block;
      font-weight: bold;
      color: ${colors.primary.default};
      line-height: 1.2;
    }
  } 
`;

const THead = styled.th`
  background: ${colors.shades[6]};
  width: 20%;
`;

const Delivery = styled.div`
  text-align: center;
  margin: .25em 0;
`;
const AvailabilityLinks = styled.p`
  margin: 0;
  display: block;
  color: ${colors.message.default};
  font-weight: bold;
  font-size: .88em;
  text-decoration: none;
`;
const HelpIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  color: ${colors.carphone};
`;
const TickIcon = styled(Icon)`
  width: 20px;
  height: 15px;
  margin: -10px 5px 0 0;
  color: #488020;
  font-size: 16px;
`;
const CompareProductTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const RemoveButton = styled.button`
  align-self: flex-end;
  color: ${({ theme }) => theme.colors.link.default};
  padding-top: 5px;
  display: inline-block;
  text-decoration: none;
  border: 0;
  margin-bottom: 7px;
  height: auto;
  display: flex;
  align-items: center;
  span {
    width: 20px;
    height: 20px;
  }
`;
const ProductTitleLink = styled.a`
  text-decoration: none;
  color: ${colors.shades[2]};
  &:hover {
    text-decoration: underline;
  }
`;
const ProductImage = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
  border: 0;
  width: 150px;
`;
const ProductTitle = styled.strong`
  display: block;
  font-weight: bold;
  color: ${colors.primary.default};
  text-decoration: none;
  margin: 0 0 5px;
  line-height: 1.2;
  text-align: center;
`;

const AddToBasketError = styled.div`
  display: flex;
  flex-direction: column;
  jutify-content: center;
  align-items: center;
  margin-top: 5px;
  border 1px solid ${({ theme }) => theme.colors.error.default};
  background-color: #ffdede;
`;

const InnerContainer = styled.div`
  padding: 3px 0;
`;

const ErrorText = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.error.default};
  margin: 0;
  font-size: 12px;
`;

const ErrorTextBold = styled(ErrorText)`
  && {
    font-weight: bold;
  }
`;

const ShowDifferences = styled(OnOffSwitch)`
  margin-top: 10px;
  div {
    height: 26px;
    border: 1px solid #ccc;
  }
`;

const StyledTr = styled.tr`
  ${(props) => props.hasHover && `
    &:hover {
      td {
        background: #fcf8e3;
      }   
    }
  `}
`;

export {
  CompareTable,
  StyledTr,
  Cell,
  THead,
  CellProduct,
  Delivery,
  CompareProductContainer,
  AvailabilityLinks,
  HelpIcon,
  TickIcon,
  ProductImage,
  ProductTitle,
  ProductTitleLink,
  RemoveButton,
  CompareProductTitleContainer,
  SpinnerContainer,
  InnerContainer,
  ErrorText,
  AddToBasketError,
  ErrorTextBold,
  Separator,
  ShowDifferences,
  SectionHeader,
  Chevron,
  StickyTable
};
